// Sync-health payload fetch — same OIDC bearer pattern as ClientHealth.
import { getUser } from '../../auth/authService';

const ANALYTICS_HOST = process.env.REACT_APP_ANALYTICS_MICROSERVICE_URL ?? '';

export async function getSyncHealth() {
    const user = await getUser();
    const res = await fetch(`${ANALYTICS_HOST}/api/sync-health`, {
        headers: {
            Authorization: user?.access_token ? `Bearer ${user.access_token}` : '',
        },
    });
    if (!res.ok) {
        let detail = `HTTP ${res.status}`;
        try {
            const body = await res.json();
            detail = body?.detail ?? detail;
        } catch { /* non-JSON body */ }
        throw new Error(detail);
    }
    return res.json();
}
